import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { BrandCreatorSetting, setBrandCreatorIndividualOrders } from '../../api/payment/brand-deal.api';
import { apiErrorMessage } from '../../utils/api-error-message';

interface Props {
  setting: BrandCreatorSetting | null;
  disabled?: boolean;
  onChanged: (s: BrandCreatorSetting) => void;
}

// Công tắc "Nhận đơn từ cá nhân" (spec §2.5): tắt thì cá nhân không mời thẳng hay đặt quảng cáo livestream được,
// nhưng creator vẫn tự ứng tuyển/nhận brief của cá nhân trên sàn.
const IndividualOrdersToggle: React.FC<Props> = ({ setting, disabled, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const on = setting?.acceptIndividualOrders ?? true;

  const toggle = async () => {
    try {
      setBusy(true);
      onChanged(await setBrandCreatorIndividualOrders(!on));
    } catch (e) {
      toast.error(apiErrorMessage(e, 'Không đổi được cài đặt, thử lại sau.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ui-divider mt-3 flex items-center justify-between gap-4 border-t pt-3">
      <div>
        <div id="individual-orders-label" className="ui-heading text-[14px] font-bold">
          Nhận đơn từ cá nhân
        </div>
        <p className="ui-muted text-[13px]">
          Cho phép cá nhân đã định danh mời bạn đăng bài hoặc đặt quảng cáo livestream. Tắt thì bạn vẫn tự ứng tuyển được
          đơn của cá nhân trên sàn.
        </p>
      </div>
      <button
        type="button"
        role="switch"
        aria-labelledby="individual-orders-label"
        aria-checked={on}
        disabled={!setting || disabled || busy}
        onClick={toggle}
        className={`relative h-7 w-12 shrink-0 rounded-full transition-colors disabled:opacity-60 ${
          on ? 'bg-[#0057FF]' : 'bg-gray-300 dark:bg-slate-600'
        }`}
      >
        <span
          className={`absolute top-0.5 size-6 rounded-full bg-white shadow transition-transform ${
            on ? 'translate-x-[22px]' : 'translate-x-0.5'
          }`}
        />
      </button>
    </div>
  );
};

export default IndividualOrdersToggle;
